import {Typography} from '@mui/material'
import type {SxProps, Theme} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {getFormattedDate} from '@app/util-functions'
import {useUserContext} from '@containers/App/UserProvider'
import type {UserContextProps} from '@containers/App/UserProvider'

type TimeDisplayProps = {
  date: Date | string
  showDate?: boolean
  showTime?: boolean
  showSeconds?: boolean
  showYear?: boolean
  variant?: 'caption' | 'body1' | 'body2'
  sx?: SxProps<Theme>
}

const DateTimeDisplay: FC<TimeDisplayProps> = ({
  date,
  showDate = true,
  showTime = false,
  showSeconds = false,
  showYear = false,
  variant = 'caption',
  sx,
  ...rest
}): ReactElement => {
  const {currentUser} = useUserContext() as UserContextProps
  const formattedDate = getFormattedDate(date, currentUser, {
    showDate,
    showTime,
    showSeconds,
    showYear,
  })

  return (
    <Typography
      variant={variant}
      component="span"
      data-testid="mbai-main-date-display-component"
      sx={sx}
      {...rest}
    >
      {formattedDate}
    </Typography>
  )
}

export default DateTimeDisplay
